import { useMutation } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

interface AddPayoutNoteInput {
  payoutId: string;
  note: string;
}

export const useAddPayoutNoteAction = () => {
  return useMutation({
    mutationFn: async ({ payoutId, note }: AddPayoutNoteInput) => {
      const response = await api.post(`/dashboard/payouts/${payoutId}/notes`, { note });
      return response.data;
    },
  });
};
